import React, { useEffect, useState } from "react";

const DEFAULT_MESSAGES = [
  "Calculating your cosmic blueprint…",
  "Evaluating your birth details…",
  "Aligning planetary positions…",
  "Decoding your nakshatras…",
  "Drawing your divisional charts…",
  "Hold tight — the stars are speaking…",
  "Almost there — finalising predictions…",
];

/**
 * Full-bleed or inline cosmic loader with rotating texts and a triple-orbit animation.
 * Usage: <CosmicLoader messages={["..."]} mode="overlay" /> or mode="inline".
 */
export default function CosmicLoader({
  messages = DEFAULT_MESSAGES,
  mode = "overlay",            // "overlay" | "inline"
  interval = 2200,
  title = "",
}) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setIdx(i => (i + 1) % messages.length), interval);
    return () => clearInterval(id);
  }, [interval, messages.length]);

  const wrapStyle = mode === "overlay"
    ? { position: "fixed", inset: 0, zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", background: "radial-gradient(ellipse at center, #1a0833 0%, #120021 70%)" }
    : { display: "flex", alignItems: "center", justifyContent: "center", padding: "60px 16px", width: "100%" };

  return (
    <div style={wrapStyle} data-testid="cosmic-loader">
      {/* Subtle nebula glow */}
      {mode === "overlay" && (
        <>
          <div style={{ position: "absolute", width: "520px", height: "520px", background: "radial-gradient(circle, rgba(157,78,221,0.18), transparent 70%)", borderRadius: "50%", top: "-100px", left: "-120px", pointerEvents: "none" }} />
          <div style={{ position: "absolute", width: "480px", height: "480px", background: "radial-gradient(circle, rgba(255,209,102,0.15), transparent 70%)", borderRadius: "50%", bottom: "-100px", right: "-120px", pointerEvents: "none" }} />
        </>
      )}

      <div style={{ textAlign: "center", maxWidth: "440px", padding: "0 20px", position: "relative" }}>
        {/* Cosmic orbit ring */}
        <div className="cosmic-orbit" style={{ margin: "0 auto 28px" }}>
          <div className="orbit-ring orbit-ring-1" />
          <div className="orbit-ring orbit-ring-2" />
          <div className="orbit-ring orbit-ring-3" />
          <div className="orbit-core">✦</div>
          <div className="orbit-planet orbit-planet-1" />
          <div className="orbit-planet orbit-planet-2" />
          <div className="orbit-planet orbit-planet-3" />
        </div>

        {title && (
          <h2 className="font-cinzel" style={{ color: "#FFD166", fontSize: "1.4rem", marginBottom: "10px", letterSpacing: "0.5px" }}>{title}</h2>
        )}

        <div data-testid="cosmic-loader-text" key={idx} className="loader-fade" style={{ color: "#E2D8F0", fontSize: "1.02rem", lineHeight: 1.6, minHeight: "1.6em", fontFamily: "'DM Sans', sans-serif" }}>
          {messages[idx]}
        </div>

        <div style={{ marginTop: "22px", display: "flex", gap: "6px", justifyContent: "center" }}>
          {messages.map((_, i) => (
            <div key={i} style={{
              width: i === idx ? "20px" : "6px",
              height: "6px",
              borderRadius: "10px",
              background: i === idx ? "#FFD166" : "rgba(255,255,255,0.18)",
              transition: "all 350ms ease",
            }} />
          ))}
        </div>
      </div>
    </div>
  );
}
